export function initFaqPage() {
  const container = document.querySelector('[data-faq]') as HTMLElement
  if (!container) return

  const anchors = container.querySelectorAll(
    'a[href^="#"]'
  ) as NodeListOf<HTMLAnchorElement>

  anchors.forEach((anchor) => {
    anchor.addEventListener('click', (event) => {
      event.preventDefault()
      const targetId = anchor.getAttribute('href')?.substring(1)
      const targetElement = document.getElementById(targetId!)

      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' })
      }

      anchors.forEach((a) => a.classList.remove('is-active'))
      anchor.classList.add('is-active')
    })
  })
}
